import {Box,Typography} from '@mui/material';
import { ReactComponent as HighPriorityIcon } from "../../img/notifications/highPriority.svg"
import { ReactComponent as NoPriorityIcon } from "../../img/notifications/noPriority.svg"
import { colors } from '../../Theme/tokens';


export const HighPriority = () => {
    return(
        <Box sx={{display:"flex", gap:1}}>
            <HighPriorityIcon  sx={{width:"16px", height:"16px"}}/>
            <Typography sx={{fontSize:"12px", fontWeight:500, lineHeight:"140%",color: colors.neutral.outlinedText, letterSpacing:"0%",}}>High Priority</Typography>
        </Box>
    )
}

export const NoPriority = () => {
    return(
        <Box sx={{display:"flex", gap:1}}>
            <NoPriorityIcon  sx={{width:"16px", height:"16px"}}/>
            <Typography sx={{fontSize:"12px",fontWeight:500, lineHeight:"140%",color: colors.neutral.outlinedText, letterSpacing:"0%",}}>No Priority</Typography>
        </Box>
    )
}

export const retrievePriorityIcon  = (priorityIndex) => {
    const getPriorityIcon = {
        0: NoPriority,
        1: HighPriority,
    }
    return getPriorityIcon[priorityIndex] || NoPriority
}
